import React from "react";
import LoadAttendance from "../../components/LoadAttendance";
import PageTitle from "../../components/PageTitle";
import { Skeleton } from "../../components/ui/Skeleton";
import { Card } from "../../components/ui/Card";
import EmptyState from "../../components/ui/EmptyState";
import { axiosget } from "../../helpers/httprequest";

const MainAttendance = () => {
  const [loading, setloading] = React.useState(true);
  const [data, setdata] = React.useState(undefined);

  React.useEffect(() => {
    (async () => {
      try {
        const req = await axiosget("ms_course/student");
        if (req.data?.type) {
          throw new Error(req.data?.message);
        }
        setdata(req.data);
      } catch ({ message }) {
        console.warn(message);
      }
      setloading(false);
    })();
  }, []);

  return (
    <div>
      <PageTitle title="My Semester Attendance" sub="Track your attendance across all registered courses" />

      {loading ? (
        <div className="space-y-3 mt-4">
          <Skeleton className="h-12 w-full" />
          {[...Array(5)].map((_, i) => <Skeleton key={i} className="h-14 w-full" />)}
        </div>
      ) : !data || data.length === 0 ? (
        <EmptyState variant="no-data" title="No Attendance Data" description="No courses found for the current semester." />
      ) : (
        <Card padding="none" className="mt-4 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-neutral-50 border-b border-neutral-200">
                <tr>
                  {["#", "Code", "Title", "Credit", "Level/Semester", "Held", "Attended", "Percentage"].map((h) => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-neutral-100">
                {data?.map((v, i) => (
                  <tr key={v._id || i} className="hover:bg-neutral-50 transition-colors">
                    <td className="px-4 py-3.5 text-sm font-semibold text-neutral-500">{i + 1}</td>
                    <td className="px-4 py-3.5 text-sm font-bold text-neutral-900">{v.courseinfo?.code}</td>
                    <td className="px-4 py-3.5 text-sm text-neutral-700">{v.courseinfo?.name}</td>
                    <td className="px-4 py-3.5 text-sm text-neutral-700">{v.courseinfo?.credit}</td>
                    <td className="px-4 py-3.5 text-sm text-neutral-700">{v.level} — {v.semester}</td>
                    <LoadAttendance session={v.session} course={v.course} />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
};

export default MainAttendance;
